/**
 * @function jsonToQueryString
 * This function allows you convert an object to QueryString.
 * This function is use to send some params in the request as a QueryString
 * @param obj
 * @returns QueryString
 */
export const jsonToQueryString = (
  obj: any,
  keepEmptyStrings: boolean = false,
) =>
  Object.keys(obj)
    .filter(
      (key) =>
        obj[key] !== null &&
        obj[key] !== undefined &&
        (keepEmptyStrings ? true : obj[key] !== ''),
    )
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
    .join('&')
